import {ComponentChild, h} from 'preact'
import Panel from '../panel'

const NavigationBar = ({ switcher }: {switcher: ComponentChild}) => {
  return (
    <Panel
      customClass='homepage-widget'
      title={
        <div className='panel-title-with-switch'>
          Navigation bar
          { switcher }
        </div>
      }
    />
  )
}

export default NavigationBar
